import { useSelector } from 'react-redux';
import { Store } from 'modules/store';

const useCurrentRoleScreen = (expectedRolePath: string): any | null => useSelector((state: Store) => {
  const {
    roleScreen,
    roleScreenPath,
    roleScreenStatus,
  } = state.auth;

  if (roleScreenStatus !== 'ready') {
    return null;
  }
  if (roleScreenPath !== expectedRolePath) {
    return null;
  }
  if (!roleScreen || !roleScreen.menuId) {
    return null;
  }

  return roleScreen;
});

export default useCurrentRoleScreen;
